<template>

  <router-view />

</template>

<script lang="js">

/**
 * The main purpose of this component is to allow a place to route between the
 * list-based layout (for the previous main view, as well as settings and system
 * views) and the grid-based layout (for the new layout of the main view).
 */
export default {

  // #region Properties

  name: 'App'

  // #endregion Properties

}

</script>